import type {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from "@mui/material/styles";

type muiButton = {
  defaultProps?: ComponentsProps["MuiButton"];
  styleOverrides?: ComponentsOverrides<Theme>["MuiButton"];
  variants?: ComponentsVariants["MuiButton"];
};

// We'll be declaring the override properties to override the default properties of the MuiButton component.

declare module "@mui/material/Button" {
  export interface ButtonPropsVariantOverrides {
    contained: boolean;
    outlined: boolean;
    text: boolean;
    primary: true;
    secondary: true;
    neutral: true;
  }
}

export const Button: muiButton = {
  defaultProps: {
    disableElevation: true,
    disableRipple: false,
  },
  styleOverrides: {
    root: {
      textTransform: "none",
      borderRadius: 8,
      padding: "10px 16px",
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: 1,
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      },
    },
    sizeLarge: {
      padding: "12px 24px",
      fontSize: "1.125rem",
    },
    sizeSmall: {
      padding: "6px 12px",
      fontSize: "0.875rem",
    },
    containedPrimary: {
      "&:hover": {
        backgroundColor: "#2d2a42", // darker shade of primary
      },
    },
    containedSecondary: {
      "&:hover": {
        backgroundColor: "#056a94", // darker shade of secondary
      },
    },
    outlinedPrimary: {
      borderColor: "#3c3759",
      "&:hover": {
        backgroundColor: "rgba(60, 55, 89, 0.04)",
      },
    },
    outlinedSecondary: {
      borderColor: "#068cc1",
      "&:hover": {
        backgroundColor: "rgba(6, 140, 193, 0.04)",
      },
    },
  },
  variants: [
    {
      props: { variant: "primary" },
      style: {
        backgroundColor: "#f27143",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "#2d2a42",
        },
      },
    },
    {
      props: { variant: "secondary" },
      style: {
        backgroundColor: "#068cc1",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "#056a94",
        },
      },
    },
    {
      props: { variant: "neutral" },
      style: {
        backgroundColor: "#f5f5f5",
        color: "#3c3759",
        "&:hover": {
          backgroundColor: "#e0e0e0",
        },
      },
    },
  ],
};
